document.querySelectorAll('.ui-dropdown').forEach(function (block) {
    const panel = block.querySelector('.ui-dropdown__panel')

    panel.addEventListener('click', () => {
        block.classList.toggle('ui-dropdown--open')
    })

    document.addEventListener('click', ({ target }) => {
        if (!target.closest('.ui-dropdown')) block.classList.remove('ui-dropdown--open')
    })
})

